import {
  Grid2,
  PaymentFailedDialog,
  PaymentSuccessDowngradeDialog,
  PaymentSuccessUpgradeDialog,
} from '@aibees/shared/components';
import { PlanSlug } from '@aibees/shared/definition';
import { PlanCard } from '@aibees/shared/features';
import { useResponsive } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Box, Card, CardContent } from '@mui/material';
import { memo } from 'react';
import { usePlanConfigs } from './hooks/use-plan-configs';
import { usePlanList } from './hooks/use-plan-list';
import * as SX from './sx';
import type { PricingCardsProps as Props } from './types';

export const PricingCards = memo(({ className, yearly }: Props) => {
  const { productCards, isLoading } = usePlanList(yearly);
  const { bySlug, byName } = usePlanConfigs();
  const free = bySlug[PlanSlug.FREE];
  const isSmall = useResponsive('down', 'sm');

  return (
    <Card
      className={classnames('PricingCards', className)}
      sx={SX.root}
      variant="filled"
      color="default"
    >
      <CardContent padding="extra" sx={SX.cardContent}>
        <Grid2 container spacing={1} columns={48}>
          <PaymentSuccessDowngradeDialog />
          <PaymentSuccessUpgradeDialog />
          <PaymentFailedDialog />
          {productCards.map(({ product, plans, isFree }) => (
            <Grid2
              key={product.id}
              xs={48}
              sm={isSmall ? 48 : 24}
              md={24}
              lg={12}
              xl={12}
            >
              <Box sx={SX.boxPlan}>
                <PlanCard
                  plans={plans}
                  yearly={yearly}
                  isFree={isFree}
                  title={product.name}
                  config={
                    (product.name ? byName[product.name] : undefined) ??
                    free ??
                    undefined
                  }
                  isLoading={isLoading}
                  isMostPopular={product.metadata?.label === 'MOST_POPULAR'}
                />
              </Box>
            </Grid2>
          ))}
        </Grid2>
      </CardContent>
    </Card>
  );
});

PricingCards.displayName = 'PricingCards';
